<template>
  <el-dialog :visible.sync="formModalShow" :title="'Create Contact'" @closed="$emit('close');" width="30%">
    <div class="row d-flex justify-content-between align-items-center" v-loading="loading">
      <div class="col-12">
        <div class="row">
          <div class="col-4">First Name</div>
          <div class="col-8 p-1">
            <input class="form-control" v-model="guarantor.first_name"
              :class="[{ 'is-invalid': form.errors.has('first_name') }, 'form-control']" />
          </div>
        </div>
        <div class="row">
          <div class="col-4">Last Name</div>
          <div class="col-8 p-1">
            <input class="form-control" v-model="guarantor.last_name"
              :class="[{ 'is-invalid': form.errors.has('last_name') }, 'form-control']" />
          </div>
        </div>
        <div class="row">
          <div class="col-4">Email</div>
          <div class="col-8 p-1">
            <input class="form-control" v-model="guarantor.email"
              :class="[{ 'is-invalid': form.errors.has('email') }, 'form-control']" />
          </div>
        </div>
        <div class="row">
          <div class="col-4">Phone Number</div>
          <div class="col-8 p-1">
            <input class="form-control" v-model="guarantor.phone"
              :class="[{ 'is-invalid': form.errors.has('phone') }, 'form-control']" />
          </div>
        </div>
        <div class="row">
          <div class="col-4">Address</div>
          <div class="col-8 p-1">
            <google-maps-autocomplete class="w-100" :value="guarantor.postal_address"
              v-on:address-components="saveAddresses" placeholder="10 Street Name"></google-maps-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="col-4">Date of birth</div>
          <div class="col-8 p-1">
            <el-date-picker v-model="guarantor.date_of_birth" value-format="yyyy-MM-dd" format="dd/MM/yyyy" type="date"
              class="w-100" placeholder="Pick a day"></el-date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-4">Sign</div>
          <div class="col-8 p-1">
            <el-switch v-model="guarantor.is_signatory" :active-value="1" :inactive-value="0"></el-switch>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-right">
            <el-button class="btn-primary" @click="onSubmit">Save</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import Guarantor from "../../../modelsPortal/Guarantor";
import Business from "../../../modelsPortal/Business";
import Form from "form-backend-validation";
export default {
  props: {
    initial_business: {
      type: Object,
    },
    initial_guarantor: {
      type: Object,
    },
  },
  data() {
    return {
      guarantor: this.initial_guarantor ? this.initial_guarantor : {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        postal_address: '',
        date_of_birth: '',
        extra_attributes: {
          postal_address: null,
        },
        is_signatory: 0,
      },
      formModalShow: true,
      form: new Form(),
      loading: false,
    }
  },
  methods: {
    onSubmit: function () {
      this.loading = true;
      new Guarantor(this.guarantor).for(new Business(this.initial_business))
        .save()
        .then(res => {
          this.$message.success('Successfully saved!');
          this.$emit('getData');
          this.$emit('close');
        })
        .catch(errors => {
          this.form.errors.record(errors.response.data.errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveAddresses: function (address) {
      this.guarantor.extra_attributes.postal_address = address;
    },
  },
}
</script>